import * as React from 'react';
import { __ } from 'react-i18n';
import { FormInput, FormWrapper } from './FormInput';

interface Props {
  city: string;
  zip: string;
  onChange: string;
}

function CityZip({ city, zip, onChange }: Props) {
  return (
    <FormWrapper>
      <FormInput
        name="city"
        type="text"
        label={__('Mesto')}
        value={city}
        maxWidth={100}
        maxWidthPx={224}
        marginRight={16}
        onChange={onChange}
      />
      <FormInput
        name="zip"
        type="text"
        label={__('PSČ')}
        value={zip}
        maxWidth={34}
        maxWidthPx={80}
        onChange={onChange}
      />
    </FormWrapper>
  );
}

export { CityZip };
